import * as React from "react";
var SvgIconExtraLarge = function SvgIconExtraLarge(props) {
  return /*#__PURE__*/React.createElement("svg", props);
};
export default SvgIconExtraLarge;